/// <amd-module name="VSS/Features/MarkdownEditor/Formatting/Link" />
import { expandCursorToWord, getTrimmedSelectionRange } from "./Common";
import { IMarkdownFormattingArgs, IMarkdownFormattingResult } from "./Contracts";

export function wrapWithLinkSign(formattingArgs: IMarkdownFormattingArgs): IMarkdownFormattingResult {
    const { text = "" } = formattingArgs;
    let selectionStart = Math.min(formattingArgs.selectionStart || 0, text.length);
    let selectionEnd = Math.min(formattingArgs.selectionEnd || 0, text.length);

    let hasSelection = selectionEnd > selectionStart;
    if (hasSelection) {
        // If we do have a selection, trim beginning/trailing whitespace
        const trimmedSelectionRange = getTrimmedSelectionRange(text, selectionStart, selectionEnd);
        selectionStart = trimmedSelectionRange.start;
        selectionEnd = trimmedSelectionRange.end;
    } else {
        const cursorWord = expandCursorToWord(text, selectionStart);
        selectionStart = cursorWord.start;
        selectionEnd = cursorWord.end;
        hasSelection = selectionEnd > selectionStart;
    }
    const firstPart = text.substring(0, selectionStart);
    const middlePart = text.substring(selectionStart, selectionEnd);
    const endPart = text.substring(selectionEnd);

    let startSign: string;
    let endSign: string;
    if (hasSelection) {
        // If we have a selection, wrap it inside [] and move the cursor to be inside ()
        startSign = `[${text.substring(selectionStart, selectionEnd)}](`;
        endSign = ")";
    } else {
        // If we don't have a selection, put the cursor inside []
        startSign = "[";
        endSign = "]()";
    }

    const replacementText = startSign + endSign;
    const newCursorPointer = firstPart.length + startSign.length;
    return {
        insertSelectionEnd: firstPart.length + middlePart.length,
        insertSelectionStart: firstPart.length,
        insertText: replacementText,
        finalSelectionEnd: newCursorPointer,
        finalSelectionStart: newCursorPointer,
        finalText: firstPart + replacementText + endPart
    };
}
